import React, { useContext, useState } from 'react'
import * as yup from 'yup';
import { useNavigate, Link } from 'react-router-dom';
import { getImages } from '../../Common/const';
import { UserContext } from '../../Context/UserContext';


const validationSchemaStep1 = yup.object({
    signin_username: yup.string().required("Please enter your username"),
    // Sorry! VIN must have 17 characters.
    signin_password: yup.string().required("Please enter your password"),
});
const Login = () => {
    const [formikData, setFormikData] = useState({
        signin_username: "",
        signin_password: ""
    });

    const navigate = useNavigate();

    const {loginUser, loggedInCheck,} = useContext(UserContext);
    
    const [redirect, setRedirect] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [formData, setFormData] = useState({
        signin_username:'',
        signin_password:'',
        terms:true
    });

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.name == "terms" ? e.target.checked : e.target.value
        })
    }

    const submitForm = async (e) => {
        e.preventDefault();

        console.log("submit Form")
        if(!formData.terms){
            setErrMsg('Please accept terms & conditions');
            return;
        }

        if(formData.signin_username.trim() === '' || formData.signin_password.trim() === ''){
            setErrMsg('Please Fill in all Required Fields!');
            return;
        }

        const data = await loginUser(formData);
        if(data.success){
            e.target.reset();
            setRedirect('Signing in...');
            await loggedInCheck();
            navigate("/admin/manage-vehicles");
            console.log("success")
            return;
        }
        setErrMsg(data.message);
    }

  return (
    <>
        <div className="page-login-bg page-signin">
            <div className="signin-header text-start">
                <img src={getImages('eec-logo.png')} alt='European Exotic Center' />
            </div>
            <div className="signin-container">
                <div className="signin-form">
                    <div className='sif-title mb-3 text-uppercase'>Login</div>
                    <form className='custom-form login-form' onSubmit={submitForm} method="post">
                        <div className='form-group mb-3'>
                            <label>Username</label>
                            <input type='text' name="signin_username" className='form-control' onChange={onChangeInput}/>
                        </div>
                        <div className='form-group mb-3'>
                            <label>Password</label>
                            <input type='password' name="signin_password" className='form-control' onChange={onChangeInput}/>
                        </div>
                        <div className="form-group mb-3">
                            <label className="custom-checkbox login-checkbox mb-1">
                                <input type="checkbox" id="remember_me"/>
                                <label htmlFor="remember_me">Remember Me</label>
                            </label>
                        </div>
                        <div className="form-actions">
                            <button type='submit' className='orange-white-btn w-100 d-inline-block font-1-2em fw-700 text-uppercase mb-36'>Login</button>
                            <button className="forgot-password p-0" type='button'>Forgot your password?</button>
                        </div> 
                    </form>
                </div>
            </div>
        </div>
    </>
  )
}

export default Login